export class UserNotificationModel {
  public userNotificationId: number;
  public userMedicineId?: number;
  public userMedicineHistoryId?: number;
  public userId?: number;
  public notificationScheduleTypeId: number;
  public notificationAlarmTypeId: number;
  public alarmTime: string;
  public description: string;
  public isActive: boolean;
  public oneTimeExecutionDate?: string;
  public notificationFrequencyId?: number;
  public notificationFrequencyCounter?: number;
  public isSingleDailyOccurance?: boolean;
  public startDate?: string;
  public endDate?: string;
  public dailyFrequencyCounter?: number;
  public startTime?: string;
  public endTime?: string;
  public canBeActivated: boolean;
  public minutesForIntake: number;
  public caretakerUserId: number;
  public timeZoneOffsetInMinutes: number;
  public cronExpression: string;
  public caretakerName: string;
}